import { render, staticRenderFns } from "./activeUsers.vue?vue&type=template&id=1b332a4e&scoped=true"
import script from "./activeUsers.vue?vue&type=script&lang=js"
export * from "./activeUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b332a4e",
  null
  
)

export default component.exports